













import { Component, Vue, Prop } from 'vue-property-decorator';
import ResumeDetails from '@/components/ResumeDetails.vue';
import { vxm } from '../../store.vuex';
@Component({
  components: {
    ResumeDetails,
  },
})
export default class Resume extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }
   async goToNext() {
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
           this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
      }else{
        this.$emit('go-to-next');
     }
  }
}
